
// 公共组件引入
import { home } from './home'
import { order } from './order'
import { service } from './service'
import { ecology } from './ecology'
import { userHome } from './userHome'
import { system } from './system'
import IdentityService from '@/service/identity';
import { redirectbyrole } from '@/common/jdyrole';

import main from '@/views/main'

const identity = new IdentityService();
export const routes = [
  {
    path: '/',
    components: { default: () => import('@/views/home/index') }
  },
  {
    path: '/order',
    component: main,
    children: [order]
  },
  {
    path: '/service',
    component: main,
    children: [service]
  },
  {
    path: '/ecology',
    component: main,
    children: [ecology]
  },
  {
    path: '/userHome',
    component: main,
    children: [userHome]
  },
  {
    path: '/system',
    component: main,
    children: [system]
  },
  { path: '/login.html', components: { default: () => import('@/views/identity/login') }, meta: { title: '筋斗云-登录' } },
  { path: '/oidc/callback.html', components: { default: () => import('@/views/oidc/callback') } },
  { path: '/oidc/silent.html', components: { default: () => import('@/views/oidc/silent') } },
  // { path: '/forgot', components: { default: () => import('@/views/identity/forgot') } },
  { path: '/forgotreset', components: { default: () => import('@/views/identity/forgot-reset-password') }, meta: { title: '筋斗云-重置密码' } },
  { path: '/emalitoreset', components: { default: () => import('@/views/identity/emailto-reset-password') }, meta: { title: '筋斗云-重置密码' } },
  { path: '/customerprojectdetail', components: { default: () => import('@/views/service/project-details/project-details-customer') }, meta: { title: '筋斗云-项目详情' } },
  { path: '/projectlog', components: { default: () => import('@/views/service/project-details/project-log') }, meta: { title: '筋斗云-项目日志' }  },
  { path: '/projectevaluation', components: { default: () => import('@/views/service/project-details/project-evaluation') }, meta: { title: '筋斗云-评价详情' } },
  { path: '/projectdemand', name: 'customerDemand', components: { default: () => import('@/views/service/project-demand-customer/index') }, meta: { title: '筋斗云-网站需求' } },
  { path: '/activetoreset', components: { default: () => import('@/views/identity/active-reset-password') }, meta: { title: '筋斗云-激活用户' } },
  { path: '/createuseremailtemp', components: { default: () => import('@/views/identity/CreateUserEmailTemp') }, meta: { title: '筋斗云-激活用户' }  },
  // 无权限
  { path: '/norole.html', components: { default: () => import('@/views/identity/norole') }, meta: { title: '拒绝访问' }  },
  // 404
  { path: '*', components: { default: () => import('@/views/identity/nopage') }, meta: { title: '页面走丢了' }  },

]






// WEBPACK FOOTER //
// ./src/router/routes.js